import { defineMessage } from 'services/localization';

export const messages = {
    pay: defineMessage('pay_with_approvalmax'),
    areYouSure: defineMessage('are_you_sure_you_want_to_stop_payment'),
    yesStop: defineMessage('yes_stop'),
    disabledTooltip: defineMessage('bank_account_is_disconnected'),
    scheduledDateShouldBeGreater: defineMessage('scheduled_date_should_be_greater_or_equal_tomorrow'),
    scheduledDateShouldNoLater: defineMessage('scheduled_date_should_n_ys_from_the_current_one'),
    toProceedWithWalletsPay: defineMessage('to_proceed_with_the_pay_the_wallet_manager_role'),
};
